export default __webpack_public_path__ + "static/media/opensea.b609f5b8.png";